<label class="zk-w-full" for="password">{{ fieldLabel }}</label>
<div class="password-input">
	<div (click)="changeFieldType()">
		<span
			*ngIf="fieldType"
			class="freud-icon freud-icon-eye freud-icon-md"
		></span>
		<span
			*ngIf="!fieldType"
			class="freud-icon freud-icon-eye-off freud-icon-md"
		></span>
	</div>
	<input
		[ngModel]="passwordModel"
		(ngModelChange)="checkPasswordItem($event)"
		class="zk-w-full"
		(focusout)="sendDataonFocusOut()"
		[type]="fieldType ? 'password' : 'text'"
		[placeholder]="'SIGN_UP.SUBSCRIPTION_DATA.PASSWORD_DESCRIPTION' | translate"
	/>
</div>
<div *ngIf="getErrorMessage">
	<span>{{ getErrorMessage }}</span>
</div>
